var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003D21OrMorePeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97.968,
    height: 97.968,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 19.571864,
    height: 19.571864,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m49.445618,51.088443c0.985067,0 1.923835,0.212177 2.777317,0.593843c0.063965,-1.435017 0.544011,-2.762063 1.314032,-3.860611c-0.542183,-0.11676 -1.101423,-0.178907 -1.674066,-0.178907l-5.425485,0c-0.571424,0 -1.130665,0.061519 -1.668584,0.177023c0.820585,1.173249 1.310986,2.605128 1.318906,4.155649c0.997251,-0.564967 2.141318,-0.886999 3.357879,-0.886999z",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    stroke: "null",
    cx: 49.148941,
    cy: 40.60453,
    r: 6.274763,
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m59.19151,58.436159c3.254316,0 5.89091,-2.718122 5.89091,-6.070262c0,-3.353395 -2.636593,-6.070262 -5.89091,-6.070262c-3.223856,0 -5.83791,2.66853 -5.886645,5.978611c1.857434,1.200242 3.159891,3.230358 3.397477,5.586901c0.756619,0.365345 1.597917,0.575011 2.489168,0.575011l0,0.000001z",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m39.10759,46.295007c-3.254926,0 -5.891518,2.717493 -5.891518,6.070262s2.636593,6.069634 5.891518,6.069634c1.152596,0 2.224168,-0.347141 3.133086,-0.93659c0.289368,-1.940349 1.298803,-3.637135 2.740765,-4.79218c0.006092,-0.113621 0.016448,-0.225987 0.016448,-0.340864c0,-3.352768 -2.637812,-6.070262 -5.8903,-6.070262z",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m63.017859,46.165693c1.857434,1.200242 3.159891,3.230358 3.396868,5.587528c0.75601,0.364718 1.597917,0.575011 2.489168,0.575011c3.254316,0 5.89091,-2.717493 5.89091,-6.070262c0,-3.352768 -2.636593,-6.070262 -5.89091,-6.070262c-3.223248,-0.000627 -5.8373,2.66853 -5.886036,5.977983l0.000001,0.000001z",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    stroke: "null",
    cx: 49.445618,
    cy: 58.632642,
    r: 5.781561,
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m61.691643,58.849841l-4.961279,0c-0.054218,2.045182 -0.900998,3.886976 -2.241226,5.210883c3.696592,1.133702 6.402024,4.666631 6.402024,8.839857l0,1.940978c4.897923,-0.186439 7.72093,-1.61518 7.906733,-1.713107l0.393539,-0.205899l0.040816,0l0,-6.300015c0.001218,-4.28622 -3.382247,-7.772697 -7.540608,-7.772697l0.000001,0z",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m71.40342,52.741914l-4.96006,0c-0.053609,2.045182 -0.900998,3.886976 -2.240616,5.210883c3.696592,1.133702 6.401414,4.666004 6.401414,8.83923l0,1.940978c4.897313,-0.185811 7.72093,-1.614551 7.906733,-1.713107l0.393539,-0.205271l0.042035,0l0,-6.300015c0,-4.285592 -3.383466,-7.772697 -7.543045,-7.772697z",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m44.398443,64.060096c-1.333526,-1.317629 -2.17787,-3.14938 -2.240008,-5.181379c-0.183368,-0.013811 -0.365516,-0.029504 -0.553149,-0.029504l-4.997221,0c-4.159579,0 -7.543654,3.487104 -7.543654,7.773325l0,6.300643l0.01523,0.0973l0.420953,0.136848c3.184259,1.025102 6.02676,1.495909 8.494607,1.645311l0,-1.902685c0.001218,-4.172599 2.705432,-7.705528 6.403242,-8.839857z",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m51.944534,65.117213l-4.999049,0c-4.159579,0 -7.543654,3.48836 -7.543654,7.772697l0,6.300643l0.015839,0.098556l0.420344,0.135592c3.96951,1.277454 7.41816,1.704318 10.255787,1.704318c5.544278,0 8.757169,-1.628989 8.955766,-1.732567l0.393539,-0.205899l0.041425,0l0,-6.300643c0.001828,-4.285592 -3.381638,-7.772697 -7.539999,-7.772697l0.000001,0z",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m29.308699,52.521577c0.891252,0 1.732549,-0.210294 2.489168,-0.575011c0.237586,-2.35717 1.539434,-4.387914 3.396868,-5.588156c-0.048735,-3.308826 -2.662789,-5.977983 -5.886036,-5.977983c-3.254926,0 -5.891518,2.717493 -5.891518,6.070889c0,3.352768 2.636593,6.070262 5.891518,6.070262l0.000001,-0.000001z",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m33.862681,58.14677c-1.339009,-1.323907 -2.186398,-3.166328 -2.240008,-5.212139l-4.96067,0c-4.159579,0.000627 -7.543045,3.487733 -7.543045,7.773325l0,6.300643l0.042035,0l0.393539,0.205271c0.186413,0.096672 3.008811,1.527296 7.906733,1.712479l0,-1.940978c0,-4.172599 2.704214,-7.705528 6.401414,-8.838602l0.000001,0.000001z",
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m36.198687,45.694887c0.706665,-0.295039 1.78494,-0.657246 2.814478,-0.657246c1.198285,0 2.370376,0.317637 3.415753,0.922152c0.232713,-0.235403 0.445931,-0.491521 0.639654,-0.765845c-0.992987,-1.343995 -1.535169,-2.991189 -1.535169,-4.685464c0,-1.141234 0.247333,-2.27368 0.718849,-3.302549c-1.0734,-0.999365 -2.442869,-1.544872 -3.898235,-1.544872c-2.648777,0 -4.954578,1.847443 -5.629565,4.449433c1.978663,1.186432 3.267719,3.26049 3.474236,5.584389l0,0.000001z",
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m55.279264,44.850574c0.204689,0.335214 0.444103,0.650968 0.715804,0.944751c0.9674,-0.497171 2.031054,-0.758312 3.102018,-0.758312c1.053297,0 2.062732,0.277461 2.724317,0.509726c0.207126,-2.519127 1.685641,-4.742588 3.898844,-5.869384c-0.811447,-2.388557 -3.008202,-4.018802 -5.495542,-4.018802c-1.608273,0 -3.131259,0.680472 -4.230855,1.878203c0.386229,0.949145 0.581781,1.946627 0.581781,2.969218c-0.00061,1.566215 -0.447758,3.058985 -1.296366,4.3446z",
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m69.378058,38.789155c0.985068,0 1.923836,0.212176 2.777317,0.593843c0.063966,-1.435018 0.544011,-2.762063 1.314032,-3.860612c-0.542183,-0.116759 -1.101423,-0.178906 -1.674066,-0.178906l-5.425485,0c-0.571424,0 -1.130665,0.061518 -1.668584,0.177023c0.820585,1.17325 1.310986,2.605128 1.318906,4.15565c0.997251,-0.564968 2.141318,-0.886999 3.357879,-0.886999z",
    id: "svg_33"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    stroke: "null",
    cx: 68.495132,
    cy: 27.844018,
    r: 6.274761,
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m78.391139,45.829388c3.254316,0 5.89091,-2.718121 5.89091,-6.070261c0,-3.353396 -2.636593,-6.070262 -5.89091,-6.070262c-3.223856,0 -5.83791,2.66853 -5.886645,5.978612c1.857434,1.200242 3.159891,3.230358 3.397477,5.586901c0.756619,0.365345 1.597916,0.575011 2.489168,0.575011z",
    id: "svg_35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m82.217489,33.558922c1.857434,1.200243 3.159891,3.230359 3.396868,5.587528c0.75601,0.364719 1.597917,0.575011 2.489169,0.575011c3.254316,0 5.89091,-2.717493 5.89091,-6.070261c0,-3.352768 -2.636593,-6.070262 -5.89091,-6.070262c-3.223248,-0.000627 -5.837301,2.66853 -5.886036,5.977983z",
    id: "svg_37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m80.891273,46.24307l-4.961278,0c-0.054219,2.045183 -0.900999,3.886976 -2.241226,5.210884c3.696591,1.133701 6.402023,4.666631 6.402023,8.839857l0,1.940977c4.897923,-0.186439 7.72093,-1.615179 7.906734,-1.713107l0.393539,-0.205899l0.040816,0l0,-6.300015c0.001218,-4.28622 -3.382247,-7.772697 -7.540608,-7.772697z",
    id: "svg_39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m90.603049,40.750108l-4.96006,0c-0.053609,2.045183 -0.900998,3.886976 -2.240617,5.210884c3.696592,1.133701 6.401414,4.666004 6.401414,8.83923l0,1.940977c4.897314,-0.185811 7.72093,-1.614551 7.906734,-1.713107l0.393539,-0.205271l0.042035,0l0,-6.300015c0,-4.285592 -3.383466,-7.772697 -7.543045,-7.772697z",
    id: "svg_40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m74.478893,32.243804c0.204689,0.335214 0.444103,0.650968 0.715804,0.944751c0.967401,-0.497171 2.031054,-0.758312 3.102018,-0.758312c1.053297,0 2.062732,0.277462 2.724317,0.509727c0.207126,-2.519128 1.685641,-4.742588 3.898844,-5.869384c-0.811447,-2.388557 -3.008202,-4.018802 -5.495543,-4.018802c-1.608273,0 -3.131258,0.680472 -4.230855,1.878203c0.386229,0.949145 0.581781,1.946627 0.581781,2.969218c-0.000609,1.566215 -0.447758,3.058985 -1.296366,4.3446z",
    id: "svg_46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m19.782165,46.371933c0.891252,0 1.732549,-0.210294 2.489168,-0.575011c0.237586,-2.357169 1.539434,-4.387914 3.396868,-5.588156c-0.048735,-3.308826 -2.662788,-5.977983 -5.886035,-5.977983c-3.254926,0 -5.891519,2.717493 -5.891519,6.070889c0,3.352768 2.636593,6.070261 5.891519,6.070261z",
    id: "svg_55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m24.336147,51.997126c-1.339009,-1.323907 -2.186399,-3.166329 -2.240008,-5.212139l-4.96067,0c-4.159579,0.000627 -7.543045,3.487732 -7.543045,7.773325l0,6.300643l0.042035,0l0.393539,0.205271c0.186413,0.096672 3.008811,1.527296 7.906734,1.712479l0,-1.940978c0,-4.172598 2.704214,-7.705528 6.401414,-8.838602z",
    id: "svg_56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m29.366617,38.789155c0.985068,0 1.923836,0.212176 2.777317,0.593843c0.063966,-1.435018 0.544011,-2.762063 1.314032,-3.860612c-0.542183,-0.116759 -1.101423,-0.178906 -1.674066,-0.178906l-5.425485,0c-0.571424,0 -1.130665,0.061518 -1.668584,0.177023c0.820585,1.17325 1.310986,2.605128 1.318906,4.15565c0.997251,-0.564968 2.141318,-0.886999 3.357879,-0.886999z",
    id: "svg_60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m50.895738,31.858863c-0.009001,0.397973 0.021159,0.80018 0.089799,1.203113c1.067044,0.155287 2.088061,0.562714 2.97593,1.190924c0.873223,0.617847 1.562173,1.439991 1.986837,2.020623c1.514614,-1.966955 3.925643,-2.943014 6.361145,-2.578942c0.600574,-2.456185 -0.351565,-5.0963 -2.413664,-6.555334c-1.333319,-0.943387 -2.958679,-1.272609 -4.508772,-0.92465c-0.185774,1.013433 -0.555392,1.95509 -1.100516,2.802856c-0.835425,1.298094 -2.001896,2.273366 -3.39076,2.84141z",
    id: "svg_61"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    stroke: "null",
    cx: 48.855817,
    cy: 24.154232,
    r: 6.274765,
    id: "svg_62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m42.145525,36.502715c0.372179,-0.695791 0.992854,-1.689097 1.792956,-2.368743c0.931242,-0.791043 2.032688,-1.317944 3.207769,-1.53825c0.039625,-0.336566 0.051672,-0.676363 0.037648,-1.017438c-1.578003,-0.388963 -2.987567,-1.311153 -4.004019,-2.627852c-0.684665,-0.886906 -1.171844,-1.930257 -1.42266,-3.041109c-1.433742,-0.068051 -2.825287,0.41206 -3.956318,1.372815c-2.058486,1.748581 -2.742086,4.70648 -1.705629,7.174195c2.249491,-0.384176 4.495573,0.376704 6.050253,2.046382z",
    id: "svg_63"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    stroke: "null",
    cx: 29.656188,
    cy: 27.690277,
    r: 6.274764,
    id: "svg_64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m17.145619,32.780635c0.706665,-0.295039 1.784939,-0.657246 2.814478,-0.657246c1.198285,0 2.370375,0.317637 3.415753,0.922152c0.232712,-0.235403 0.44593,-0.491521 0.639654,-0.765845c-0.992987,-1.343994 -1.53517,-2.991189 -1.53517,-4.685463c0,-1.141234 0.247333,-2.27368 0.71885,-3.302549c-1.073401,-0.999365 -2.442869,-1.544872 -3.898235,-1.544872c-2.648777,0 -4.954578,1.847443 -5.629565,4.449432c1.978663,1.186432 3.267719,3.26049 3.474236,5.58439z",
    id: "svg_65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m10.548756,40.376031c0.891252,0 1.732549,-0.210294 2.489168,-0.575011c0.237586,-2.357169 1.539434,-4.387914 3.396868,-5.588156c-0.048735,-3.308826 -2.662788,-5.977983 -5.886035,-5.977983c-3.254926,0 -5.891519,2.717493 -5.891519,6.070889c0,3.352768 2.636593,6.070261 5.891519,6.070261z",
    id: "svg_66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    stroke: "null",
    d: "m15.102737,46.001224c-1.339009,-1.323907 -2.186399,-3.166329 -2.240008,-5.212139l-4.96067,0c-4.159579,0.000627 -7.543045,3.487732 -7.543045,7.773325l0,6.300643l0.042035,0l0.393539,0.205271c0.186413,0.096672 3.008811,1.527296 7.906734,1.712479l0,-1.940978c0,-4.172598 2.704214,-7.705528 6.401414,-8.838602z",
    id: "svg_67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003D21OrMorePeople);
export default __webpack_public_path__ + "static/media/003d-21-or-more-people.aedb3fa2dcdaf5c106ce8c512303d1b1.svg";
export { ForwardRef as ReactComponent };